import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function AdminContact() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/contact").then((r) => setList(r.data)); }, []);
  return (
    <div data-testid="admin-contact-page">
      <div className="pg-micro mb-2">// Contact Messages</div>
      <h1 className="text-[#F7FAFC] text-3xl pg-display mb-8" style={{ fontFamily: "'Exo 2'" }}>Customer Enquiries</h1>
      <div className="space-y-3">
        {list.map((m) => (
          <div key={m.id} className="pg-card p-5">
            <div className="flex flex-wrap justify-between gap-3 mb-3">
              <div>
                <div className="text-[#F7FAFC] pg-heading text-lg" style={{ fontFamily: "'Rajdhani'" }}>{m.name}</div>
                <div className="text-[#00C2D6] text-sm pg-mono">{m.email}</div>
              </div>
              <div className="text-right">
                <span className="pg-badge-cyan">{m.enquiry_type}</span>
                {m.organisation && <div className="text-xs text-[#9CA8B8] mt-1">{m.organisation}</div>}
              </div>
            </div>
            <div className="text-sm text-[#F7FAFC] leading-relaxed whitespace-pre-wrap">{m.message}</div>
            <div className="mt-3 text-xs pg-mono text-[#9CA8B8]">{m.created_at?.slice(0, 19)}</div>
          </div>
        ))}
        {list.length === 0 && <div className="text-[#9CA8B8] text-center py-12">No messages yet</div>}
      </div>
    </div>
  );
}
